// hier storefront behaviour, ported from the live site (site/src/assets/site.js): reels load and play only while on
// screen, plan cards drive the CTA labels and carry the picked plan to the questionnaire links, the sticky CTA shows
// only when no other CTA is visible, the trust marquee can be paused, and rail dots follow the swipe. FAQ items are
// native <details> and need no script.
// No analytics or tracking here: the owner connects Google Analytics through Shopify's own channel. data-track
// attributes in the markup are inert ids kept from the live site.
(function () {
  'use strict';
  var REEL_THRESHOLD = 0.35; // share of a reel that must be on screen before it plays
  var RAIL_THRESHOLD = 0.6; // share of a rail card that must be visible to mark its dot current
  var IDLE_FALLBACK_MS = 600; // hero video start delay where requestIdleCallback is missing
  var IDLE_TIMEOUT_MS = 2500; // latest start of the hero video after the load event
  var PICK_KEY = 'hier-pick-v1'; // sessionStorage: the plan last picked on a landing page in this tab, and when
  var START_LINKS = 'a[href*="/pages/start"]'; // questionnaire links: /pages/start or /<language>/pages/start
  var START_PATH = /\/pages\/start\/?$/;
  var conn = navigator.connection || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var autoplayAllowed = !reduceMotion && !conn.saveData;
  var hasIO = 'IntersectionObserver' in window;
  var wired = new WeakSet();

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  // Wires each element once, also when the theme editor re-renders the section around it.
  function once(el) {
    if (wired.has(el)) return false;
    wired.add(el);
    return true;
  }

  // ---------- reels: load and play only while on screen ----------
  var reelLabels = document.querySelector('[data-reel-play]');
  var reelByEl = new Map();
  var heroReel = null;
  var heroReady = false;
  var heroPending = false;

  function setupReel(fig) {
    var video = fig.querySelector('video');
    var toggle = fig.querySelector('[data-reel-toggle]');
    var userPaused = false;
    var loaded = false;
    if (!video) return null;
    // The toggle is named for what it does next: "Play video" while paused, "Pause video" while playing.
    function showState(playing) {
      if (!toggle) return;
      toggle.hidden = false;
      if (reelLabels) toggle.setAttribute('aria-label', reelLabels.getAttribute(playing ? 'data-reel-pause' : 'data-reel-play'));
    }
    function load() {
      if (loaded) return;
      loaded = true;
      video.src = video.getAttribute('data-src');
      video.load();
    }
    function play() {
      load();
      var p = video.play();
      if (p && p.catch) p.catch(function () { fig.classList.add('is-paused'); showState(false); });
    }
    video.addEventListener('playing', function () { fig.classList.add('is-playing'); fig.classList.remove('is-paused'); showState(true); });
    video.addEventListener('pause', function () { fig.classList.add('is-paused'); showState(false); });
    if (toggle) {
      toggle.addEventListener('click', function () {
        if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); }
      });
    }
    if (!autoplayAllowed) {
      fig.classList.add('is-paused');
      showState(false);
      return null;
    }
    return {
      enter: function () { if (!userPaused) play(); },
      leave: function () { if (loaded && !video.paused) video.pause(); },
    };
  }

  var reelIO = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var r = reelByEl.get(en.target);
      if (!r) return;
      if (en.isIntersecting) {
        // Never compete with the LCP poster: the hero video starts after load.
        if (en.target === heroReel && !heroReady) { heroPending = true; return; }
        r.enter();
      } else {
        if (en.target === heroReel) heroPending = false;
        r.leave();
      }
    });
  }, { threshold: REEL_THRESHOLD }) : null;

  function initReels(root) {
    each(root.querySelectorAll('[data-reel]'), function (fig) {
      if (!once(fig)) return;
      var r = setupReel(fig);
      if (!r || !reelIO) return;
      reelByEl.set(fig, r);
      if (fig.closest('.hero')) heroReel = fig;
      reelIO.observe(fig);
    });
  }

  function startHero() {
    heroReady = true;
    var r = heroReel && reelByEl.get(heroReel);
    if (heroPending && r) r.enter();
  }
  function afterLoad() {
    (window.requestIdleCallback || function (cb) { setTimeout(cb, IDLE_FALLBACK_MS); })(startHero, { timeout: IDLE_TIMEOUT_MS });
  }

  // ---------- plan cards: the checked card names the offer button and the sticky bar ----------
  // Radios inside [data-offer] carry data-cta (offer button label), data-sticky and data-sticky-sub (sticky bar
  // price and line). Every applied plan is announced as a bubbling `hier:plan` event ({ value, input }) for page
  // scripts that need it.
  // The questionnaire links carry the plan checked here and when it was picked (?plan=&picked=, as on the live
  // site): the questionnaire applies it unless the customer chose a plan there since, so a page brought back by Back
  // with an older pick never overrides a later choice. A card the browser restored without a known pick time carries
  // 0 (it overrides no choice); the card checked by default and never picked leaves the links without a plan.
  var pick = readPick() || { plan: '', at: 0 };
  function readPick() {
    try {
      var p = JSON.parse(sessionStorage.getItem(PICK_KEY) || 'null');
      return p && typeof p.plan === 'string' && typeof p.at === 'number' ? p : null;
    } catch (e) { return null; } // storage blocked or the value is not ours: no stored pick
  }
  function setText(el, value) {
    if (el && value !== null) el.textContent = value;
  }
  function carryPlan(plan, at) {
    each(document.querySelectorAll(START_LINKS), function (a) {
      var url = new URL(a.getAttribute('href'), location.href);
      if (!START_PATH.test(url.pathname)) return;
      if (at < 0) { url.searchParams.delete('plan'); url.searchParams.delete('picked'); }
      else { url.searchParams.set('plan', plan); url.searchParams.set('picked', String(at)); }
      a.setAttribute('href', url.pathname + url.search + url.hash);
    });
  }
  function applyPlan(offer, input) {
    if (!input) return;
    setText(offer.querySelector('[data-offer-label]'), input.getAttribute('data-cta'));
    var sticky = document.querySelector('[data-sticky-bar]');
    if (sticky) {
      setText(sticky.querySelector('[data-sticky-price]'), input.getAttribute('data-sticky'));
      setText(sticky.querySelector('[data-sticky-sub]'), input.getAttribute('data-sticky-sub'));
    }
    carryPlan(input.value, input.value === pick.plan ? pick.at : input.defaultChecked ? -1 : 0);
    offer.dispatchEvent(new CustomEvent('hier:plan', { bubbles: true, detail: { value: input.value, input: input } }));
  }
  // A tap on a card is a pick, also on the card already checked (a page brought back by Back can show an older one).
  function choose(offer, input) {
    pick = { plan: input.value, at: Date.now() };
    try { sessionStorage.setItem(PICK_KEY, JSON.stringify(pick)); } catch (e) { /* storage blocked: this page's links still carry the pick */ }
    applyPlan(offer, input);
  }
  function isPlan(el) { return el.type === 'radio'; }
  function initOffers(root) {
    each(root.querySelectorAll('[data-offer]'), function (offer) {
      if (!once(offer)) return;
      // Back/reload: the browser restores the checked card without a change event (Chrome just before pageshow).
      var applyChecked = function () {
        pick = readPick() || pick;
        applyPlan(offer, offer.querySelector('input[type="radio"]:checked'));
      };
      offer.addEventListener('click', function (e) { if (isPlan(e.target)) choose(offer, e.target); });
      offer.addEventListener('change', function (e) { if (isPlan(e.target)) choose(offer, e.target); });
      applyChecked();
      window.addEventListener('pageshow', applyChecked);
    });
  }

  // ---------- sticky CTA: visible only when no other CTA is on screen ----------
  var stickyIO = null;
  function initSticky() {
    if (stickyIO) { stickyIO.disconnect(); stickyIO = null; }
    var sticky = document.querySelector('[data-sticky-bar]');
    if (!sticky || !hasIO) return;
    var link = sticky.querySelector('[data-sticky-cta]');
    var heroCta = document.getElementById('hero-cta');
    var watched = [heroCta, document.getElementById('offer-cta'), document.getElementById('final-cta'), document.querySelector('.foot')].filter(Boolean);
    var visible = new Set();
    var pastHero = false;
    var update = function () {
      var on = pastHero && visible.size === 0;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (link) link.tabIndex = on ? 0 : -1;
    };
    stickyIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target);
        if (en.target === heroCta) pastHero = !en.isIntersecting && en.boundingClientRect.top < 0;
      });
      update();
    });
    watched.forEach(function (el) { stickyIO.observe(el); });
  }

  // ---------- trust marquee: moving text needs a way to stop it (WCAG 2.2.2) ----------
  function initChips(root) {
    each(root.querySelectorAll('[data-chips-toggle]'), function (btn) {
      if (!once(btn)) return;
      btn.addEventListener('click', function () {
        var paused = btn.getAttribute('aria-pressed') !== 'true';
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.parentNode.classList.toggle('is-paused', paused);
      });
    });
  }

  // ---------- rails: active dot follows the swipe ----------
  function initRails(root) {
    each(root.querySelectorAll('[data-rail]'), function (rail) {
      if (!once(rail)) return;
      var track = rail.querySelector('.rail__track');
      var dots = rail.querySelectorAll('.rail__dot');
      if (!track || !hasIO || !dots.length) return;
      var items = Array.prototype.slice.call(track.children);
      var rio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var i = items.indexOf(en.target);
          each(dots, function (d, n) { if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
        });
      }, { root: track, threshold: RAIL_THRESHOLD });
      items.forEach(function (it) { rio.observe(it); });
    });
  }

  function init(root) {
    initReels(root);
    initOffers(root);
    initChips(root);
    initRails(root);
  }

  init(document);
  initSticky();
  if (reelIO) {
    if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad, { once: true });
  }
  // Theme editor: a re-rendered section brings new elements; wire them and re-watch the CTAs.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    initSticky();
  });
})();
